export default function convertForEach(component) {
  var properties = component.properties;
  var _ref = properties,
    dataSource = _ref.dataSource;
  return {
    brick: ":forEach",
    dataSource: dataSource
  };
}
//# sourceMappingURL=convertForEach.js.map